import { makeFormItemSchema } from '../../util/util';
import { createButtonListSetters } from '../button';
import { DisplayPosition } from '@/type/display-position';
import { createFormItemSetters } from '@/lowcode/cn-form/form-item';
import { ButtonPosition } from '@/type/button-position';
const add = 'add';
const remove = 'remove';
const getDefaultButtons = () => {
    return [
        {
            children: '添加一行',
            optType: 'arrayTableAdd',
            primaryKey: add,
        },
        {
            primaryKey: remove,
            children: '删除',
            optType: 'arrayTableRemove',
        },
    ];
};
const CnFormArrayCard = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArraySubAreaCard,
    ],
    title: '自增可编辑卡片',
    componentName: 'CnFormArrayCard',
    formItemBeforeHandler: (formItem, config) => {
        const { formInstance, formItemConfig, formProps, isDesign, usedComponentList, urlParams, formValue, state, _context, } = config || {};
        const { _dataSourceName } = formProps || {};
        const { options } = formItemConfig || {};
        const { config: arrayTableFormConfig, buttons } = options || {};
        if (formItem) {
            let isReadOnly = false;
            if (formItem?.readOnly === true) {
                isReadOnly = true;
            }
            formItem.type = 'array';
            let componentProps = {};
            if (!formItem['x-component-props']) {
                formItem['x-component-props'] = componentProps;
            }
            else {
                componentProps = formItem['x-component-props'];
            }
            if (componentProps) {
                formItem.items = {
                    type: 'object',
                    properties: {},
                };
                if (Array.isArray(arrayTableFormConfig) &&
                    arrayTableFormConfig.length > 0) {
                    arrayTableFormConfig.forEach((item) => {
                        const { label, name, componentName } = item || {};
                        if (name && componentName) {
                            const columnFormItem = makeFormItemSchema({
                                formItemConfig: item,
                                isDesign,
                                urlParams,
                                formValue,
                                state,
                                usedComponentList,
                                formProps,
                                _context,
                                formInstance,
                            });
                            if (item.hidden === true) {
                                columnFormItem['x-hidden'] = true;
                            }
                            formItem.items.properties[name] = columnFormItem;
                        }
                    });
                }
                // 处理按钮
                let realButtons = buttons;
                if (!buttons) {
                    realButtons = getDefaultButtons();
                }
                componentProps.hasDeleteButton = false;
                componentProps.autoIncrementTitle = formItem?.title;
                realButtons?.forEach((item) => {
                    if (item.optType === 'arrayTableAdd') {
                        componentProps.additionText = item?.children;
                    }
                    else if (item.optType === 'arrayTableRemove') {
                        componentProps.hasDeleteButton = true;
                    }
                });
                delete formItem?.['x-component-props']?.title;
            }
        }
    },
    getDefaultProps: () => {
        return {
            config: [],
        };
    },
    getPrototypeList: () => {
        const position = DisplayPosition.cnArrayTable;
        return [
            {
                name: 'config',
                title: '表单项配置',
                setter: createFormItemSetters({ position }),
            },
            {
                name: 'buttons',
                title: '按钮',
                defaultValue: getDefaultButtons(),
                // supportVariable: true,
                setter: createButtonListSetters({
                    position: ButtonPosition.arrayTableOperate,
                }),
            },
        ];
    },
};
export default CnFormArrayCard;
